import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import AccountMenu  from '../../Modules/AccountMenu'

import OnbekendeBijeenkomst from '../../Modules/Kennis/Toevoegen/OnbekendeBijeenkomst';

class MemberBijneekomstUnknownAdd extends Component {
  render() {
    return (
      <div className="route">
      <AccountMenu/>
        <div className="grey-bg">
            <h1 className="pageTitle">
                Een onbekende bijeenkomst toevoegen
            </h1>
            <Row>
              <Col md={12}>
                <OnbekendeBijeenkomst />
              </Col>
            </Row>
            {/* <Bijeenkomst /> */}
        </div>
      </div>
    );
  }  
}

export default MemberBijneekomstUnknownAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/BijeenkomstOnbekend.js